import { ReactComponent as DiscordLogo } from '../assets/social-media/discord.svg';

export const DISCORD_SUPPORT_CHANEL = {
  ImageComponent: DiscordLogo,
  alternativeText: 'Discord',
  link: 'https://discord.com/channels/913751549199667271/1009140514202853496',
};
